export const SKELETON_BASE_COLOR = '#F7F7F7';
export const SKELETON_HIGHLIGHT_COLOR = '#E6E6E6';
